"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFaxOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 6h-5V2H13v4H9.73l-.2-.12A7.15 7.15 0 006 5a7.15 7.15 0 00-3.53.88L2 6.17V25h3a5.47 5.47 0 00.69 3.14A4.24 4.24 0 009.5 30a4.25 4.25 0 003.82-1.82A5.51 5.51 0 0014 25h16zM15 4h8v5h-8zM4 7.36a5.74 5.74 0 014 0V23H4zM12 25a3.48 3.48 0 01-.39 2.1 2.41 2.41 0 01-2.11.9 2.39 2.39 0 01-2.1-.86A3.5 3.5 0 017 25h5zm16-2H10V8h3v3h12V8h3z" }),
        React.createElement("path", { d: "M13 14h2v2h-2zM18 14h2v2h-2zM23 14h2v2h-2zM13 18h2v2h-2zM18 18h2v2h-2zM23 18h2v2h-2z" })));
}
exports.default = SvgFaxOutline;
//# sourceMappingURL=FaxOutline.js.map